import {ContextStateSymbol} from '@/components/global/Context.vue';
import {STATE_MAP} from "@/utils/constants";

export const getComponent = {
    inject: {
        context: { from: ContextStateSymbol, default: null },
    },
    computed: {
        components() {
            return this.isAuth ? STATE_MAP.account : STATE_MAP.auth;
        },
        step() {
            return this.context ? this.context.step : null;
        },
        isAuth() {
            return this.context ? this.context.isAuth : null;
        },
        getComponent() {
            return this.components[this.step] || null;
        }
    },
}